module.exports = __webpack_public_path__ + "static/img/rw.9c8bbe59.png";